/**
 * Escape per valori inseriti in HTML (attributi o testo) — evita XSS da dati persistiti.
 */

/** Contenuto di attributo fra doppi apici. */
export function escapeHtmlAttr(raw) {
  return String(raw ?? '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

/** Testo destinato al DOM (titoli, paragrafi, opzioni). */
export function escapeHtmlText(raw) {
  return String(raw ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
